import { createFileRoute } from '@tanstack/react-router';
import { CoachPage } from '@/components/coach';

// No beforeLoad gate: the flag check is a viewer capability, not a role, and
// the degraded state is a quiet in-page "not available" (never a redirect
// loop or a teaser). CoachPage owns that branch via useAssistantCapabilities;
// the server enforces the flag on every create/turn regardless.
export const Route = createFileRoute('/_authed/coach/')({
  component: CoachPage,
});
